
    import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  style: {"width":"1em","height":"1em","fill":"currentColor"}
}
const _hoisted_2 = ["xlink:href"]

 function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("use", {
      "xlink:href": '#' + _ctx.name
    }, null, 8, _hoisted_2)
  ]))
}

export default {
  name: "SvgIcon",
  props: {
    name: {
      type: String,
      required: true
    }
  },
  render
}
    
export const svgNames = ["alart","dashboard","fullscreen-exit","fullscreen","hj","jk","keyboard-down","keyboard-enter","keyboard-esc","keyboard-up","lamp","LED","music","role","search","Wifi"]

    
    
   